import {Skeleton} from '@ds/components';

const CategoriesSkeleton: React.FC = () => {
  return (
    <div className="mb-2 flex gap-4 pb-2">
      {Array.from({length: 4}).map((_, index) => (
        <Skeleton.Button key={`tab-skeleton-${index}`} active size="small" className="h-8 w-20" />
      ))}
    </div>
  );
};

export default CategoriesSkeleton;
